type HandleOptionalFieldErrorsProps = {
  fieldName: string;
  fieldValue?: string | null;
  targetName: string;
  targetValue: string;
};

const handleOptionalFieldErrors = ({
  fieldName,
  fieldValue,
  targetName,
  targetValue,
}: HandleOptionalFieldErrorsProps) =>
  (targetName === fieldName && targetValue === '') || (targetName !== fieldName && fieldValue === '');

export default handleOptionalFieldErrors;
